define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"./_SizeChartSubSizeRanges",
	"./_SizeChartRevision"
], function(declare,_,_SizeChartSubSizeRanges,_SizeChartRevision) {

	var	TYPE_SIZE_CHART_REVISION = "SizeChartRevision";

	return declare(null, {
		_subSizeRangeData: null,
		_sizeChartRevisionData: null,

		displayTwoDimension: function(/*Node*/scDimension) {
			// summary: returns boolean if the SizeChartDimension is displayed as 2-d matrix
			var scRev = this._getSizeChartRevision(scDimension);
			if(_.isEmpty(scRev.SizeChartDimension2Sizes)){
				return false;
			}

			var apparelDimension = this.cacheView.getNode(scDimension.Actual);
			return apparelDimension && _.contains(apparelDimension.DimensionDependencies, scRev.Dimension2Type);
		},

		getSubSizeRangeData: function(/*Node?*/node) {
			// summary: return object containing metadata about sub size ranges
			// NOTE: This function assumes given node is child of SizeChartRevision
			var	cache = this.cacheView;
			var	data = this._subSizeRangeData = this._subSizeRangeData || {};

			node = this._getSizeChartRevision(node);

			return data[node.$URL] = data[node.$URL] || new _SizeChartSubSizeRanges(cache.getNodes(node.SizeChartSubSizeRanges));
		},

		resetSubSizeRangeData: function() {
			// summary: reset cached sub size ranges
			delete this._subSizeRangeData;
			this._subSizeRangeData = {};
		},

		getSizeChartRevisionData: function(/*Node?*/node) {
			if (!this._sizeChartRevisionData) {
				var scRev = this._getSizeChartRevision(node);
				this._sizeChartRevisionData = new _SizeChartRevision(this.cacheView, scRev);
			}

			return this._sizeChartRevisionData;
		},

		resetSizeChartRevisionData: function() {
			// summary: reset cached size chart revision
			delete this._sizeChartRevisionData;
		},

		_getSizeChartRevision: function(/*Node?*/node) {
			// summary: return SizeChartRevision node
			// NOTE: This function assumes given node is child of SizeChartRevision
			var	cache = this.cacheView;
			node = node || this.getViewNode();

			while (node && (node.$Type != TYPE_SIZE_CHART_REVISION)) {
				node = cache.getNode(node.__Parent__);
			}

			console.assert(!!node, "_getSizeChartRevision - invalid context node");

			return node;
		}
	});
});
